import request from '@/utils/request'
import config from "@/config"
// 下单
export function create(order) {
	return request.post(
	  `${config.API_URL}/orders`,
    order
	)
}
// 预报订单列表
export function list(param) {
	return request.get(
		`${config.API_URL}/orders/of/search/self/page`,
    param
	)
}
// 保存收件地址
export function saveReceive(data) {
	return request.post(
	  	`${config.API_URL}/receive_addresses/self`,
    	data
	)
}
// 保存发件地址
export function saveSend(data) {
	return request.post(
		`${config.API_URL}/send_addresses/self`,
    	data
	)
}
// 上传身份证文件
export function upload(formData) {
	return request.post(
	  	`${config.API_URL}/system_statics/upload/inof?ipurl=${config.BASE_URL}`,
		  formData
	)
}
// 修改收件地址
export function updateReceive(data) {
	return request.put(
		`${config.API_URL}/receive_addresses/self/` + data.id,
		data.data
	)
}
// 修改发件地址
export function updateSend(data) {
	return request.put(
		`${config.API_URL}/send_addresses/self/` + data.id,
		data.data
	)
}
// 删除收件地址
export function deleteReceive(data) {
	return request.delete(
		`${config.API_URL}/receive_addresses/self/` + data.id,
		data.data
	)
}
// 保存进口商地址
export function saveImporter(data) {
	return request.post(
		`${config.API_URL}/importer_addresses/self`,
		data
	)
}
// 修改进口商地址
export function updateImporter(data) {
	return request.put(
		`${config.API_URL}/importer_addresses/self/` + data.id,
		data.data
	)
}
// 删除进口商地址(批量，传 JSON.stringify(ids))
export function deleteImporter(ids) {
	return request.delete(
		`${config.API_URL}/importer_addresses/self/datch/` + ids
	)
}
// 删除发件地址
export function deleteSend(data) {
	return request.delete(
		`${config.API_URL}/send_addresses/self/` + data.id,
		data.data
	)
}
